import React, { useState } from "react";
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Fresco Combi", category: "Semi-Verticals", image: "images/fresccom.jpg", description: "Ergonomically designed display offering modern solutions for coffee and bakery services.", route: "/FrescoCombi-lower" },
  { name: "Futuro Combi", category: "Semi-Verticals", image: "images/futurocombi.png", description: "Combines modern display with practical design for a compact, efficient solution.", route: "/FuturoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "Multi-functional unit with ample space for displaying and storing coffee products.", route: "/united" },
  { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistsgrab.jpg", description: "Perfect for fast-service setups with a grab-and-go concept.", route: "/vista-grab-and-go" },
  { name: "Daisy", category: "Display", image: "images/daisy22.jpg", description: "A versatile and functional line with all the options for the food retail.", route: "/daisy-upper" },
  { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Futuristic multi-deck design offering spacious storage and display options.", route: "/futuro-2" },
  { name: "FUTURO 2", image: "images/futuro22.jpg", description: "The most complete and flexible self-service solution.",slug: "FUTURO2-upper", },
  { name: "FUTURO 2", category: "Multi decks", image: "images/futunew.jpg", description: "The most complete and flexible solution for modern food retail.", route: "/FUTURO-22" },
 
  { name: "Vista", category: "Display", image: "images/vista2.jpg", description: "Versatile design integrating seamlessly into any modern coffee shop environment.", route: "/vista" },
  { name: "Daisy", category: "Display", image: "images/newdaisy.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-lower" },
  { name: "Kubo", category: "Display", image: "images/newkubo.jpg", description: "Modern, minimal footprint, ideal for high-traffic areas in cafes.", route: "/kubo" },
  { name: "E-Line", category: "Display", image: "images/eline.jpg", description: "Compact, elegant design offering sleek solutions for modern coffee setups.", route: "/e-line" },
  { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Versatile display options suited for both large and intimate spaces.", route: "/Columbus-lower" },
  { name: "Passion Lux", category: "Display", image: "images/passionlux.jpg", description: "Luxury-inspired design with high functionality, perfect for upscale establishments.", route: "/passionlux" },
  { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "Designed to cater to high-demand, high-traffic environments in coffee shops.", route: "/victory" },
  { name: "Expo BZ", category: "Islands", image: "images/expo.png", description: "An island-style setup offering maximum accessibility and visibility for coffee service.", route: "/EXPOBZ" },
  { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "Streamlined solutions for efficient order collection in high-traffic coffee shops.", route: "/CLICK&COLLECT" },

];

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

function Takeaway() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/takeaway2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Take-Away</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Complete solutions for hot and cold Take-Away service. Meat, Pasta, Pizza, Salads… your always irresistible ready-to-take service.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Take-Away</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}
export default Takeaway;

// import React, { useState } from "react";
// import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";

// const models = [
//   { name: "E-Line", category: "Display", image: "images/eline.jpg", description: "Compact, elegant design offering sleek solutions for modern coffee setups." },
//   { name: "Kubo", category: "Display", image: "images/kubo.jpg", description: "Modern, minimal footprint, ideal for high-traffic areas in cafes." },
//   { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Versatile display options suited for both large and intimate spaces." },
//   { name: "Passion Lux", category: "Display", image: "images/passionlux.jpg", description: "Luxury-inspired design with high functionality, perfect for upscale establishments." },
//   { name: "Vista", category: "Display", image: "images/vista.jpg", description: "Versatile design integrating seamlessly into any modern coffee shop environment." },
//   { name: "Daisy", category: "Display", image: "images/daisy.png", description: "An elegant model offering both modern aesthetics and user-friendly features." },
//   { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "Streamlined solutions for efficient order collection in high-traffic coffee shops." },
//   { name: "Expo BZ", category: "Islands", image: "images/expo.png", description: "An island-style setup offering maximum accessibility and visibility for coffee service." },
//   { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Futuristic multi-deck design offering spacious storage and display options." },
//   { name: "United", category: "Multi decks", image: "images/united.png", description: "Multi-functional unit with ample space for displaying and storing coffee products." },
//   { name: "Fresco Combi", category: "Semi-Verticals", image: "images/fresccom.jpg", description: "Ergonomically designed display offering modern solutions for coffee and bakery services." },
//   { name: "Futuro Combi", category: "Semi-Verticals", image: "images/futurocombi.png", description: "Combines modern display with practical design for a compact, efficient solution." },
//   { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistsgrab.jpg", description: "Perfect for fast-service setups with a grab-and-go concept." },
//   { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "Designed to cater to high-demand, high-traffic environments in coffee shops." },
// ];

// const icons = [
//   { name: "Coffee Shop", icon: <FaCoffee /> },
//   { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
//   { name: "Fish & Seafood", icon: <FaFish /> },
//   { name: "Supermarket", icon: <FaStore /> },
//   { name: "Restaurant", icon: <FaUtensils /> },
//   { name: "Ice Cream", icon: <FaIceCream /> },
//   { name: "Chocolate", icon: <FaCookieBite /> },
// ];

// function Takeaway() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/takeaway2.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Takeaway Solutions</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover the perfect takeaway solutions for modern cafes and restaurants. Choose from a variety of models tailored for your business.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Takeaway Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Takeaway;
